import {
  Box,
  Button,
  FormControlLabel,
  Grid,
  MenuItem,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

import { textFieldDefaultStyle } from '../../../../components/UI/Typography';

export const PaperQuestion = styled(Paper)(() => ({
  minHeight: '400px',
  backgroundColor: '#FFFFFF',
  border: '1px solid #D7D8DB',
  padding: '40px',
}));

export const FlexBox = styled(Box)(() => ({
  display: 'flex',
  gap: '10px',
  alignItems: 'center',
}));

export const NumberTypography = styled(Typography)(({ theme }) => ({
  fontSize: '21px',
  fontWeight: '600',
  color: theme.palette.secondary.main,
}));

export const TitleTypography = styled(Typography)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontSize: '21px',
  fontWeight: '600',
}));

export const ShortAnswerTextField = styled(TextField)(({ theme }) => ({
  width: '100%',
  margin: '8px',
  '& .MuiInputBase-root': { borderRadius: '16px' },
  '& .MuiOutlinedInput-root': {
    borderRadius: '16px',
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.common.grey,
    },
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: theme.palette.common.grey,
  },
}));

export const FlexCenterGrid = styled(Grid)(() => ({
  display: 'flex',
  alignItems: 'center',
}));

export const SingleSelectTypo = styled(Typography)(() => ({
  marginTop: '-10px',
  fontSize: '14px',
  color: '#8B8C8E',
}));

export const MultiFormControl = styled(FormControlLabel)(({ theme }) => ({
  margin: '8px 0',
  '& .MuiButtonBase-root': {
    padding: '4px',
    color: theme.palette.common.grey,
    '&.Mui-checked': {
      color: theme.palette.common.grey,
    },
  },
  '&:hover': {
    '& .MuiTypography-root': {
      fontWeight: '600',
      fontSize: '18px',
    },
  },
  '& .MuiTypography-root': {
    fontSize: '18px',
  },
}));

export const CheckboxFormControl = styled(FormControlLabel)(({ theme }) => ({
  padding: '8px 12px 0',
  '& .MuiButtonBase-root': {
    padding: '4px',
    color: theme.palette.common.grey,
  },
  '&:hover': {
    '& .MuiTypography-root': {
      fontWeight: '600',
    },
  },
  '& .MuiTypography-root': {
    fontSize: '18px',
  },
}));

export const ListTextField = styled(TextField)(({ theme }) => ({
  margin: '40px 20px 16px',
  minWidth: '180px',
  width: 'fit-content',
  '& .MuiInputBase-root': { borderRadius: '16px' },
  '& .MuiOutlinedInput-root': {
    borderRadius: '16px',
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.common.grey,
    },
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: theme.palette.common.grey,
  },
}));

export const ListMenuItem = styled(MenuItem)(({ theme }) => ({
  '&:hover': {
    backgroundColor: '#EDEDED',
  },
  '&.Mui-selected': {
    backgroundColor: alpha(theme.palette.common.grey, 0.3),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.grey, 0.3),
    },
  },
}));

export const SubmitButton = styled(Button)(({ theme }) => ({
  margin: '40px 0 0 10px',
  border: `2px solid ${theme.palette.secondary.main}`,
  borderRadius: '8px',
  backgroundColor: 'transparent',
  color: theme.palette.secondary.main,
  fontWeight: '600',
  maxWidth: '90px',
  textTransform: 'uppercase',
}));

export const StyledDatePicker = {
  ...textFieldDefaultStyle,
  margin: '24px 6px 16px',
  minWidth: '180px',
};
